/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

export const SpinnerBallSVG = () => {
  /**
   * Spinner as exported from figma Loading Spinners as SVG. Fill color changed to currentColor.
   */
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 25.0001C0 20.9296 0.972779 17.0864 2.69854 13.6902L9.64296 17.6996C8.58958 19.9115 8 22.3869 8 25C8 27.5293 8.55239 29.9297 9.54311 32.0869L2.59842 36.1107C0.935202 32.7637 0 28.9911 0 25.0001ZM11.0337 34.6951L4.09478 38.7155C8.30585 45.1211 15.3818 49.4754 23.5 49.9558V41.9347C18.3372 41.4834 13.836 38.7243 11.0337 34.6951ZM26.5 41.9347V49.9558C34.6426 49.4739 41.7368 45.0948 45.9432 38.6575L38.9988 34.6482C36.1989 38.7029 31.6828 41.4816 26.5 41.9347ZM40.4801 32.0362L47.4317 36.0498C49.0761 32.7179 50 28.9669 50 25.0001C50 20.927 49.0259 17.0814 47.2981 13.6836L40.3591 17.704C41.4112 19.9148 42 22.3886 42 25C42 27.5095 41.4562 29.8921 40.4801 32.0362ZM38.8332 15.1163L45.7777 11.0927C41.5522 4.79215 34.5368 0.519911 26.5 0.0443115V8.06527C31.5818 8.50954 36.0227 11.1897 38.8332 15.1163ZM23.5 8.06527V0.0443115C15.4601 0.520095 8.4424 4.79545 4.21738 11.0999L11.1689 15.1134C13.9795 11.1884 18.4195 8.50943 23.5 8.06527Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 11C32.732 11 39 17.268 39 25C39 32.732 32.732 39 25 39C17.268 39 11 32.732 11 25C11 17.268 17.268 11 25 11ZM25 14.5C30.799 14.5 35.5 19.201 35.5 25C35.5 30.799 30.799 35.5 25 35.5C19.201 35.5 14.5 30.799 14.5 25C14.5 19.201 19.201 14.5 25 14.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
